export const createCanvas = (width: number, height: number, scale = 1) => {
  if (typeof document === 'undefined') {
    return null;
  }

  const canvas = document.createElement('canvas');
  canvas.width = width * scale;
  canvas.height = height * scale;
  const ctx = canvas.getContext('2d');

  if (ctx && scale !== 1) {
    ctx.scale(scale, scale);
  }

  return { canvas, ctx };
};
